export default "__VITE_ASSET__1f725357__"